<template>
  <v-dialog v-model="dialogDettaglioDocumento" fullscreen hide-overlay transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar dark :color="colorModalita" dense>
        <v-btn icon dark @click="closeDialogDocumento">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>{{dialogTitle}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark text @click="closeDialogDocumento">
            Chiudi
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-stepper v-model="stepperProduzione" dense flat :alt-labels="altLabels">
        <v-stepper-header>
          <v-stepper-step step="1" editable :complete="stepperProduzione > 1">
            Magazzini Temporanei
          </v-stepper-step>
          
          <v-stepper-step step="2" editable :complete="stepperProduzione > 2">
            Ordini di Produzione
          </v-stepper-step>
          <v-divider></v-divider>
<!--           <v-divider></v-divider>
          <v-stepper-step step="3" editable :complete="stepperProduzione > 3">
           Dichiarazione della Produzione
          </v-stepper-step> -->
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content step="1">
            <v-container fluid style="height: 80vh;">
              <v-row dense>
                <v-col v-for="magazzino in magazziniTemporanei" :key="magazzino.codice">
                  <magazzino-temporaneo
                    :magazzino="magazzino.codice"
                    :descrizione="magazzino.descrizione"
                    :sottotitolo="magazzino.sottotitolo"
                    :prodotti="magazzino.prodotti"
                    :refresh="refreshTemporanei"
                    @salvaTemporaneo="onSalvaTemporaneo"
                    @deleteTemporaneo="onDeleteTemporaneo"
                    @registraCaloPeso="onRegistraCaloPeso"
                  />
                </v-col>
              </v-row>

            </v-container>
          </v-stepper-content>
          <v-stepper-content step="2">
            <v-card dense>
              <header-produzione :locLotto="locLotto" :trigger="trigger" @aggiornaLotto="aggiornaLotto" />
              <body-produzione :locLotto="locLotto" :trigger="trigger" :magazziniTemporanei="magazziniTemporanei" @nuovaRiga="onNuovaRiga" @move="spostaRiga" @documento="onSalvaDocumento"/>
            <v-card-actions>
              <v-row align="center" justify="end">
                <v-btn color="primary" class="mt-3 mr-5" :disabled="saveDisabled" @click="salvaDocumento">Salva lotto</v-btn>
              </v-row>
            </v-card-actions>
          </v-card>            
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-card>
  </v-dialog>
</template>

<script>
  import { getAnnoRiferimento } from '@/components/helpers.js'
  import documenti from '@/services/documentiService.js'
  import prodotti from '@/services/prodottiService.js'
  import movimenti from '@/services/movimentiService.js'
  import magazzino from '@/services/magazzinoService.js'
  import configurazioni from '@/services/configurazioniService.js'

  import MagazzinoTemporaneo from './magazzinoTemporaneo.vue'
  import BodyProduzione from './bodyTable.vue'
  import HeaderProduzione from './header.vue'

  export default {
    components: {
      MagazzinoTemporaneo,
      BodyProduzione,
      HeaderProduzione
    },
    props: {
      showDialog: { type: Boolean, default: false },
      idDocumento: { type: String, default: '' },
      nuovoDocumento: Boolean,
      readOnly: Boolean,
      filtraTipiDocumento: Array,
      coloreOrdine: Boolean
    },
    data () {
      return {
        locLotto: {model: '', generale: '', source: ''},
        dialogDettaglioDocumento: false,
        trigger: 1,
        triggerLocale: 1,
        daSalvare: false,
        stepperProduzione: 1,
        confMagazzini: null,
        magazziniTemporanei: [],
        forzaDocumento: 'lottoProduzione',
        distinta: [],
        refreshTemporanei: 1
      }
    },
    async mounted() {
      if (this.idDocumento) {
        this.locLotto = await documenti.getDocumento(this.idDocumento)
        this.completaAppoggio()
      } else {
        this.locLotto = await documenti.getModello('lotto')
        this.completaAppoggio()
        this.locLotto.data = new Date()
        const tipi = await configurazioni.getConfigurazione('documenti_parametri', 'tipiDocumento')
        const tipoDocumento = tipi.find(x => x.tipoDocumento === this.forzaDocumento)
        this.locLotto.tipoDocumento = tipoDocumento
        console.log('mounted Produzione')          
      }
      this.dialogDettaglioDocumento = this.showDialog
      let magElenco = await configurazioni.getConfigurazione('magazzino_magazzini', 'magazzini')
      magElenco = magElenco.filter(x => x.temporaneo)
      this.confMagazzini = await configurazioni.getConfigurazione('magazzini_temporanei')
      let mt = this.confMagazzini.magazzini
      let modifiche = false
      for (let m of magElenco) {
        let mm = mt.find(x => x.codice === m.codice)
        if (!mm) {
          modifiche = true
          mt.push({
            codice: m.codice,
            descrizione: m.descrizione,
            sottotitolo: m.sottotitolo || '',
            prodotti: [],
            attivo: m.attivo
          })
        } else {
          if (mm.attivo !== m.attivo) {
            mm.attivo = m.attivo
            modifiche = true
          }
        }
      }
      if (modifiche) {
        await configurazioni.modificaConfigurazione(this.confMagazzini)
      }
      this.magazziniTemporanei = mt.filter(x => x.attivo)
      await this.verificaGiacenza()
    },
    watch: {
      async showDialog(value) {
        if (value) {
          this.stepperProduzione = 1
          await this.refresh()
/*           this.dialogDettaglioDocumento = true
          this.locLotto = await documenti.getDocumento(this.idDocumento) */
        }
      },
      trigger() {
        this.daSalvare = true
      },
      stepperProduzione() {
        this.trigger++
      }
    },
    computed: {
      dialogTitle() {
        // TODO: Specificare in base al tipo scelto
        return this.idDocumento ? `Documento nr. ${this.idDocumento} ${this.readOnly ? ' (sola lettura)' : ''}` : 'Nuovo lotto di Produzione'
      },
      colorModalita() {
        if (this.coloreOrdine) {
          return this.nuovoDocumento ? 'amber' : 'amber darken-4'
        } else {
          return this.nuovoDocumento ? 'success' : 'primary'
        }
      },
      saveDisabled() {
        if (this.readOnly) return true
        return !this.daSalvare
      },
      altLabels() {
        return ['xs', 'sm', 'md'].includes(this.$vuetify.breakpoint.name)
      }      
    },
    methods: {
      onChangeDistinta(value) {
        this.distinta = value												   
      },
      async onSalvaTemporaneo(codice, prodotto) {
        // TODO: Fare movimenti di carico temporaneo e scarico sorgente
        await this.movimentiTemporaneo(prodotto, 'carico')
        await configurazioni.modificaConfigurazione(this.confMagazzini)
      },
      async onDeleteTemporaneo(codice, prodotto) {
        await this.movimentiTemporaneo(prodotto, 'scarico')
        await configurazioni.modificaConfigurazione(this.confMagazzini)
      },
      async onRegistraCaloPeso(prodotto, delta) {
        await this.movimentoCaloPeso(prodotto, delta)
      },
      onMostraParcheggio(value) {
        this.mostraParcheggio = value
      },      
      spostaRiga(da, a) {
        let righe = this.locLotto.righe
        let daSpostare = JSON.parse(JSON.stringify(righe[da]))
        righe.splice(da, 1)
        // righe = _.pullAt(righe, da)
        if (a === -1) {
          righe.push(daSpostare)
        } else {
          righe.splice(a, 0, daSpostare)
        }
        this.trigger++
/*         var res = this.locLotto.righe
        debugger */
      },
      async onNuovaRiga(riga) {
        // riga.numeroOdp = await configurazioni.getNumeratore('ordineProduzione', true)
        this.locLotto.righe.push(riga)
        // await this.salvaDocumento()
        this.trigger++
      },
      async refresh() {
        this.dialogDettaglioDocumento = true
        if (this.idDocumento) {
          this.locLotto = await documenti.getDocumento(this.idDocumento)
          this.completaAppoggio()
        } else {
          this.locLotto = await documenti.getModello('xxx')
          this.completaAppoggio()
          this.locLotto.data = new Date()
        }
        this.trigger++
      },
      completaAppoggio() {
        let itm = this.locLotto
        _.set(itm,'appoggio.clienteVisibile', itm.tipoDocumento && itm.tipoDocumento.visualizzaCliente)
        _.set(itm,'appoggio.fornitoreVisibile', itm.tipoDocumento && itm.tipoDocumento.visualizzaFornitore)
        _.set(itm,'appoggio.spedizioneVisibile', itm.tipoDocumento && itm.tipoDocumento.infoSpedizione)
        _.set(itm,'appoggio.pagamentoVisibile', itm.tipoDocumento && itm.tipoDocumento.infoPagamento)
        _.set(itm,'appoggio.tipoDocumento', itm.tipoDocumento)
        const clifor = _.get(itm, 'anagrafica.cliente', '') || _.get(itm, 'anagrafica.fornitore', '')
        _.set(itm,'appoggio.clifor', clifor)
      },
      async aggiornaLotto(documento) {
        Object.assign(this.locLotto, documento)
        this.completaAppoggio()
        // await this.salvaDocumento()
        this.trigger++
      },
      async generaXmlItem(itemId) {
        const documento = await documenti.getDocumento(itemId)
        if (documento) {
          const { fattura, nomeFile, xml7File } = await xml7.creaXml7Fattura(documento)
          downloadXml(document, nomeFile, xml7File)
        }
      },
      async onSalvaDocumento(documento) {
        this.locLotto = documento
        await this.salvaDocumento()
        await this.verificaGiacenza()
        this.refreshTemporanei++
      },
      async verificaGiacenza() {
        for (let m of this.magazziniTemporanei) {
          let ids = m.prodotti.map(x => x.id || x.codice)
          ids = _.uniq(ids)
          const elenco = await prodotti.getProdottiByIds(ids)
          for (let p of m.prodotti) {
            let elP = elenco.find(x => x._id === (p.id || p.codice))
            let giacenza = _.get(elP, `magazzino.giacenzaParziale.${m.codice}.giacenza`)
            p.residuo = +(giacenza || p.quantita).toFixed(2)
          }
        }
      },
      async salvaDocumento() {
        let itm = this.locLotto
        var result
        if (!itm._id) {
          if (!itm.tipoDocumento) {
            const tipi = await configurazioni.getConfigurazione('documenti_parametri', 'tipiDocumento')
            const tipoDocumento = tipi.find(x => x.tipoDocumento === this.forzaDocumento)
            itm.tipoDocumento = tipoDocumento
          }          
          const numeratore = itm.tipoDocumento.numeratore
          const annoRiferimento = getAnnoRiferimento(itm.data)
          const numero = await configurazioni.getNumeratore(numeratore, true, annoRiferimento)
          itm._id = numero
          itm.codice = numero
          itm.magazzino = itm.magazzino || this.$store.getters['magazzini/codiceMagazzino']
          itm = JSON.parse(JSON.stringify(this.locLotto))
          delete itm.appoggio
          // const prodotti_lotto = await this.creaProdottiLotto(itm)
          // await prodotti.clearCache()

          result = await documenti.creaDocumento(itm)
          // Verifica se va creato il movimento relativo          
          // await this.verificaAggiungiMovimenti(result)
        } else {
          itm = JSON.parse(JSON.stringify(this.locLotto))
          delete itm.appoggio
          result = await documenti.aggiornaDocumento(itm)
          // I movimenti vengono generati al momento della dichiarazione della produzione
          // await this.verificaModificaMovimenti(result)
        }
        this.locLotto = result
        this.completaAppoggio()
        this.trigger++
        await this.$nextTick()
        this.daSalvare = false
        return result
      },
      async salvaXML() {
        // verificare se c'è qualcosa da salvare, altrimenti evitare
        // const doc = await this.salvaDocumento()
        // debugger
        if (this.daSalvare) {
          // await this.salvaDocumento()
        }
        await this.generaXmlItem(this.locLotto._id)
      },
      closeDialogDocumento() {
        this.dialogDettaglioDocumento = false
        this.$emit('refresh')
      },
      async creaProdottiLotto(lotto) { // TODO: Verificare
        let prog = 0
        for (let p of lotto.righe) {
          prog++
          const base = p.prodotto.codice
          const prodottoBase = await prodotti.getProdotto(base)
          let pr = {...prodottoBase}
          delete pr._rev
          delete pr.valore
          delete pr.appoggio
          delete pr.prodotto
          pr.barcode = []
          pr.descrizione = `${pr.descrizione.trim()}-L.${lotto.codice}.${prog}`
          pr.ultimoAcquisto = {} // completare
          pr.lotti.prodottoBase = false
          pr.lotti.base = base
          pr.lotti.lotto = lotto.codice
          pr.lotti.progressivo = prog
          pr.lotti.produzione = lotto.produzione
          pr.lotti.scadenza = lotto.scadenza
          pr.lotti.distinta = p.distinta
          pr._id = `${base}.${lotto.codice}.${prog}`
          pr.codice = base  // (il codice rimane lo stesso del prodotto base)
          pr.magazzino.giacenza = 0
          pr.magazzino.valore = 0
          await prodotti.creaProdotto(pr)
          p.prodotto.codice = pr._id
        }
      }, 
      async verificaAggiungiMovimenti(documento) {
        // Percorre la distinta e crea tutti i movimenti relativi ai prodotti non di appoggio
																						 
        const prodottiDocumento = documento.righe.filter(x => x.prodotto && x.prodotto.codice)
        const modello = await movimenti.getModello('lotto')
        let numErrori = 0
        for (const p of prodottiDocumento) {
          // ********************************************************************
          // Carico Prodotto Assemblato
          // ********************************************************************
            let movimento = JSON.parse(JSON.stringify(modello))
            movimento.data = new Date()
            movimento.magazzino = documento.magazzino
            movimento.prodotto = {
              codice: p.prodotto.codice,
              lotti: [],
              um: p.unitaMisura,
              quantita: +parseFloat(p.quantita).toFixed(2),
              prezzoAcquisto: _.get(p, 'appoggio.prodotto.acquisto', 0),
              prezzoUnitario: _.get(p, 'valore.listino.ivato', true) ? _.get(p, 'valore.prezzoUnitario', 0) : _.get(p, 'valore.prezzoNettoUnitario', 0),
              listino: _.get(p, 'valore.listino', null)
            }
            movimento.quantita = +parseFloat(p.quantita).toFixed(2)
            movimento.valore = p.valore ? +parseFloat(p.valore.importoTotale).toFixed(2) : 0
            movimento.causale = documento.tipoDocumento.causale
            movimento.anagrafica = {
              cliente: _.get(documento, 'anagrafica.cliente', ''),
              fornitore: ''
            }
            movimento.riferimento = {
              tipo: 'documento',
              id: documento.codice,
              data: documento.data
            }
            if (!await magazzino.creaMovimenti(movimento)) {
              numErrori++
            }
          // ********************************************************************
          // Scarico i componenti secondo la distinta base
          // ********************************************************************
          const distinta = p.distinta || []
          for (let el of distinta) {
            if (el.tipo === 'prodotto' && !el.semilavorato) {
              const prodotto = _.get(el, 'lotto.codiceProdotto' ,'') || el.codice
              let movimento = JSON.parse(JSON.stringify(modello))
              movimento.data = new Date()
              movimento.magazzino = documento.magazzino
              movimento.prodotto = {
                codice: prodotto,
                lotti: [],
                um: el.unitaMisura,
                quantita: +parseFloat(el.quantita).toFixed(2)
                // TODO: Calcolare se serve ...

                // prezzoAcquisto: _.get(p, 'appoggio.prodotto.acquisto', 0),
                // prezzoUnitario: _.get(p, 'valore.listino.ivato', true) ? _.get(p, 'valore.prezzoUnitario', 0) : _.get(p, 'valore.prezzoNettoUnitario', 0),
                // listino: _.get(p, 'valore.listino', null)
              }
              movimento.quantita = +parseFloat(el.quantita).toFixed(2)
              // movimento.valore = el.valore ? +parseFloat(el.valore.importoTotale).toFixed(2) : 0
              movimento.causale = documento.tipoDocumento.causale2
              movimento.anagrafica = {
                cliente: _.get(documento, 'anagrafica.cliente', ''),
                fornitore: ''
              }
              movimento.riferimento = {
                tipo: 'documento',
                id: documento.codice,
                data: documento.data,
                note: 'scarico distinta'
              }
              if (!await magazzino.creaMovimenti(movimento)) {
                numErrori++
              }
            }
          }
        }
      },
      async verificaModificaMovimenti(documento) {
        if (!['lottoProduzione'].includes(documento.tipoDocumento.codice)) return
        await movimenti.cancellaPerRiferimento('documento', documento.codice)
        await this.verificaAggiungiMovimenti(documento)
      },
      async movimentiTemporaneo(prodotto, tipo) {
        // ********************************************************************
        // Carico/scarico magazzino temporaneo
        // ********************************************************************
        const modello = await movimenti.getModello('lotto')
        let numErrori = 0        
        const documento = this.locLotto
        let p = await prodotti.getProdotto(prodotto.id || prodotto.codice)
        let movimento = JSON.parse(JSON.stringify(modello))
        movimento.data = new Date()
        movimento.magazzino = tipo === 'carico' ? documento.magazzinoTemporaneo : documento.magazzino
        movimento.prodotto = {
          codice: p._id,
          lotti: [],
          um: _.get(p, 'magazzino.unitaMisura') || '',
          quantita: +parseFloat(prodotto.quantita).toFixed(2),
          prezzoAcquisto: _.get(p, 'magazzino.prezzoAcquisto', 0),
          listino: _.get(p, 'prezzo.L1.base', null)
        }
        movimento.quantita = +parseFloat(prodotto.quantita).toFixed(2)
        movimento.valore =  movimento.quantita * movimento.prodotto.prezzoAcquisto || 0
        movimento.causale = tipo === 'carico' ? documento.tipoDocumento.causale : documento.tipoDocumento.causale2
        movimento.anagrafica = {
          cliente: _.get(documento, 'anagrafica.cliente', ''),
          fornitore: ''
        }
        movimento.riferimento = {
          tipo: 'documento',
          id: documento.codice,
          data: documento.data,
          note: tipo === 'carico' ? 'carico temporaneo' : 'scarico temporaneo'
        }
        if (!await magazzino.creaMovimenti(movimento)) {
          numErrori++
        }
        // ********************************************************************
        // Scarico/carico magazzino sorgente
        // ********************************************************************
        movimento = JSON.parse(JSON.stringify(modello))
        movimento.data = new Date()
        movimento.magazzino = tipo === 'carico' ? documento.magazzino : documento.magazzinoTemporaneo
        movimento.prodotto = {
          codice: p._id,
          lotti: [],
          um: _.get(p, 'magazzino.unitaMisura') || '',
          quantita: +parseFloat(prodotto.quantita).toFixed(2),
          prezzoAcquisto: _.get(p, 'magazzino.prezzoAcquisto', 0),
          listino: _.get(p, 'prezzo.L1.base', null)
        }
        movimento.quantita = +parseFloat(prodotto.quantita).toFixed(2)
        movimento.valore =  movimento.quantita * movimento.prodotto.prezzoAcquisto || 0
        movimento.causale = tipo === 'carico' ? documento.tipoDocumento.causale2 : documento.tipoDocumento.causale
        movimento.anagrafica = {
          cliente: _.get(documento, 'anagrafica.cliente', ''),
          fornitore: ''
        }
        movimento.riferimento = {
          tipo: 'documento',
          id: documento.codice,
          data: documento.data,
          note: tipo === 'carico' ? 'scarico per temporaneo' : 'carico da temporaneo'
        }
        if (!await magazzino.creaMovimenti(movimento)) {
          numErrori++
        }
      },
      async movimentoCaloPeso(prodotto, delta) {
        // ********************************************************************
        // Calo peso scarica il magazzino origine
        // ********************************************************************
        const modello = await movimenti.getModello('lotto')
        let numErrori = 0        
        const documento = this.locLotto
        let p = await prodotti.getProdotto(prodotto.id || prodotto.codice)
        let movimento = JSON.parse(JSON.stringify(modello))
        movimento.data = new Date()
        movimento.magazzino = documento.magazzino
        movimento.prodotto = {
          codice: p._id,
          lotti: [],
          um: _.get(p, 'magazzino.unitaMisura') || '',
          quantita: +parseFloat(delta).toFixed(2),
          prezzoAcquisto: _.get(p, 'magazzino.prezzoAcquisto', 0),
          listino: _.get(p, 'prezzo.L1.base', null)
        }
        movimento.quantita = +parseFloat(delta).toFixed(2)
        movimento.valore =  movimento.quantita * movimento.prodotto.prezzoAcquisto || 0
        movimento.causale = 'scarico' // TODO: mettere su impostazioni (era documento.tipoDocumento.causale2)
        movimento.anagrafica = {
          cliente: _.get(documento, 'anagrafica.cliente', ''),
          fornitore: ''
        }
        movimento.riferimento = {
          tipo: 'documento',
          id: documento.codice,
          data: documento.data,
          note: 'registrazione calo peso'
        }
        await magazzino.creaMovimenti(movimento)
      }
    }
  }
</script>
